// import { useEffect, useState } from "react";
import styled from "styled-components";
import { getLocale } from "react-i18nify";
import moment from "moment";

import font from "src/styles/font";
import device from "src/styles/device";

import { Grid } from "@mui/material";
import { checkNotEmpty } from "src/common";

const ProjectName = styled.div`
  width: 100%;
  padding: 0 40px 24px;
  border-bottom: 10px var(--darkwhite-color) solid;
  color: var(--secondary-color);
  font-size: ${font.size.md};
  font-weight: 400;

  @media ${device.tabletL} {
    padding: 0 64px 24px;
  }
  @media ${device.mobileL} {
    padding: 0 20px 16px;
  }
`;

const SpanLabel = styled.div`
  font-size: ${font.size.md};
  color: var(--secondary-color);
  font-weight: 600;
  margin-bottom: 8px;

  span {
    font-size: ${font.size.md};
    font-weight: 400;
    color: var(--primary-color);
  }
`;

const DataLabel = styled.div`
  font-size: ${font.size.md};
  color: var(--secondary-color);
  font-weight: 400;

  margin-right: 8px;
`;

const DataText = styled.div`
  font-size: ${font.size.md};
  color: var(--darkgrey-color);
  font-weight: 400;
`;

const SummaryDetailGrid = ({ formData }) => {
  return (
    <>
      <Grid
        container
        sx={{
          m: 0,
          mb: { sm: 3, xs: 2 },
          // px: { xs: 3, sm: 5, md: 5 },
          py: { xs: 3, md: 5 },
          width: "100%",
          borderRadius: { md: "24px" },
          background: "var(--white-color)",
          boxShadow: {
            md: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
          },
          borderBottom: {
            xs: "10px var(--darkwhite-color) solid",
            md: "none",
          },
        }}
      >
        {/* (Head) Product name */}
        <Grid
          item
          xs={12}
          sx={{
            mb: {
              xs: 2,
              sm: 3,
            },
          }}
        >
          <ProjectName>{formData?.project || ""}</ProjectName>
        </Grid>

        {/* Customer detail */}
        <Grid
          item
          xs={12}
          sx={{
            px: {
              xs: 3,
              sm: 8,
              md: 5,
            },
            mb: 3,
            borderBottom: "1px solid var(--lightgrey-color)",
          }}
        >
          <SpanLabel>ข้อมูลติดต่อ</SpanLabel>

          <Grid
            container
            spacing={3}
            rowSpacing={1}
            columnSpacing={2}
            sx={{
              mt: 0,
              mb: 3,
              ".MuiGrid-item": {
                display: "flex",
                alignItems: "center",
              },
            }}
          >
            <Grid item xs={12} md={6}>
              <DataLabel>
                {getLocale() === "th" ? `ชื่อ` : `Full name`}:
              </DataLabel>

              <DataText>{formData?.contact?.full_name || "-"}</DataText>
            </Grid>

            {formData?.company_name !== "" && (
              <>
                <Grid item xs={12} md={6}>
                  <DataLabel>
                    {getLocale() === "th" ? `บริษัท` : `Company Name`}:
                  </DataLabel>

                  <DataText>{formData?.company_name || "-"}</DataText>
                </Grid>

                <Grid item xs={12} md={6}>
                  <DataLabel>
                    {getLocale() === "th" ? `สาขา` : `Branch`}:
                  </DataLabel>

                  <DataText>{formData?.branch || "-"}</DataText>
                </Grid>
              </>
            )}

            <Grid item xs={12} md={6}>
              <DataLabel>
                {getLocale() === "th" ? `เลขประจำตัวผู้เสียภาษี` : `ID Tax`}:
              </DataLabel>

              <DataText>{formData?.contact?.tax_id || "-"}</DataText>
            </Grid>

            <Grid item xs={12} md={6}>
              <DataLabel>
                {getLocale() === "th" ? `อีเมล` : `E-mail`}:
              </DataLabel>

              <DataText>{formData?.contact?.email || "-"}</DataText>
            </Grid>

            <Grid item xs={12} md={6}>
              <DataLabel>
                {getLocale() === "th" ? `เบอร์` : `Phone Number`}:
              </DataLabel>

              <DataText>{formData?.contact?.phone_number || "-"}</DataText>
            </Grid>

            <Grid item xs={12} md={6}>
              <DataLabel>
                {getLocale() === "th" ? `เบอร์บ้าน` : `Tel.`}:
              </DataLabel>

              <DataText>{formData?.contact?.tel || "-"}</DataText>
            </Grid>

            <Grid item xs={12} md={6}>
              <DataLabel>{getLocale() === "th" ? `โทรสาร` : `Fax`}:</DataLabel>

              <DataText>{formData?.contact?.fax || "-"}</DataText>
            </Grid>
          </Grid>
        </Grid>

        {/* Address */}
        <Grid
          item
          container
          xs={12}
          sx={{
            px: {
              xs: 3,
              sm: 8,
              md: 5,
            },
            mb: 3,
            borderBottom: "1px solid var(--lightgrey-color)",
          }}
        >
          <Grid item xs={12} sx={{ mb: 1 }}>
            <SpanLabel>ที่อยู่</SpanLabel>
          </Grid>

          <Grid item xs={12} sx={{ mb: 3 }}>
            <DataText>
              {formData?.contact?.address}
              {formData?.contact?.sub_district !== "" &&
                formData?.contact?.district !== "" &&
                formData?.contact?.province !== "" &&
                formData?.contact?.zipcode !== "" &&
                `, ${formData?.contact?.sub_district}, ${formData?.contact?.district}, ${formData?.contact?.province} ${formData?.contact?.zipcode}`}
            </DataText>
          </Grid>
        </Grid>

        {/* Document Detail */}
        <Grid
          item
          container
          xs={12}
          sx={{
            px: {
              xs: 3,
              sm: 8,
              md: 5,
            },
          }}
        >
          <SpanLabel>ข้อมูลเอกสาร</SpanLabel>

          <Grid
            container
            spacing={3}
            rowSpacing={1}
            columnSpacing={2}
            sx={{
              mt: 0,
              ".MuiGrid-item": {
                display: "flex",
                alignItems: "center",
              },
            }}
          >
            {checkNotEmpty(formData?.running_number) ? (
              <Grid item xs={12} md={6}>
                <DataLabel>
                  {getLocale() === "th" ? `เลขที่เอกสาร` : `Document no.`}:
                </DataLabel>

                <DataText>
                  {formData?.running_number || "-"}
                </DataText>
              </Grid>
            ) : null}

            <Grid item xs={12} md={6}>
              <DataLabel>
                {getLocale() === "th" ? `วันที่เอกสาร` : `Document date`}:
              </DataLabel>

              <DataText>
                {moment(formData?.document_date).format("DD/MM/YYYY")}
              </DataText>
            </Grid>

            <Grid item xs={12} md={6}>
              <DataLabel>
                {getLocale() === "th" ? `อายุเอกสาร` : `Document aging`}:
              </DataLabel>

              <DataText>{`${formData?.aging || "0"} วัน`}</DataText>
            </Grid>

            <Grid item xs={12} md={6}>
              <DataLabel>
                {getLocale() === "th" ? `วันหมดอายุเอกสาร` : `Expire date`}:
              </DataLabel>

              <DataText>
                {moment(formData?.expire_date).format("DD/MM/YYYY")}
              </DataText>
            </Grid>

            <Grid item xs={12} md={6}>
              <DataLabel>
                {getLocale() === "th" ? `เลขที่เซล` : `Sale code`}:
              </DataLabel>

              <DataText>{formData?.sale_code || "-"}</DataText>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default SummaryDetailGrid;
